import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Wireframing and prototyping</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>User interface design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>User experience design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Usability testing</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Design consulting</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Front end development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive web design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>JavaScript development</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Accessibility testing</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>SEO optimization</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Design consulting</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Graphics Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Brand identity design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Print design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Illustration</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Photo editing and manipulation</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Social media design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Design consulting</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services
